import { v4 as uuid } from "uuid";
import { JournalEntryLineProxyObject } from "./JournalEntryDrawer";

const sumAmounts = (amounts: Array<number | null | undefined>) =>
    amounts.reduce<number>((acc, amount) => (amount ? acc + amount : acc), 0);

export function calculateDebitAndCreditTotals(
    lines: JournalEntryLineProxyObject[],
) {
    const debitAmount = sumAmounts(lines.map((line) => line?.debitAmount));
    const creditAmount = sumAmounts(lines.map((line) => line?.creditAmount));
    return { debitAmount, creditAmount };
}

export const DEFAULT_NUMBER_OF_LINES = 20;

export function buildEmptyLines(
    size: number = DEFAULT_NUMBER_OF_LINES,
): JournalEntryLineProxyObject[] {
    return new Array(size).fill(null).map(() => ({
        id: uuid(),
        accountId: "",
        debitAmount: null,
        creditAmount: null,
        description: "",
    }));
}

function readOptionalStringArray<T>(value: T): string[] | undefined {
    if (!Array.isArray(value)) {
        return undefined;
    }
    const classIds = value.filter(
        (item): item is string => typeof item === "string",
    );
    return classIds;
}

export function spreadsheetRowToJournalEntryLine<
    T extends Record<string, unknown>,
>(row: T): JournalEntryLineProxyObject {
    const empty = buildEmptyLines(1)[0];
    const classIds = readOptionalStringArray(row.classIds);
    return {
        id: typeof row.id === "string" ? row.id : empty.id,
        accountId: typeof row.accountId === "string" ? row.accountId : "",
        debitAmount:
            typeof row.debitAmount === "number" ? row.debitAmount : null,
        creditAmount:
            typeof row.creditAmount === "number" ? row.creditAmount : null,
        description: typeof row.description === "string" ? row.description : "",
        ...(classIds !== undefined ? { classIds } : {}),
        ...(typeof row.counterpartyId === "string" ||
        row.counterpartyId === null
            ? { counterpartyId: row.counterpartyId }
            : {}),
        ...(typeof row.excludeFrom1099 === "boolean"
            ? { excludeFrom1099: row.excludeFrom1099 }
            : {}),
        ...(typeof row.transactionId === "number" || row.transactionId === null
            ? { transactionId: row.transactionId }
            : {}),
    };
}
